<template>
    <Head>
        <title>Ошибка</title>
        <meta name="description" :content="'Что то пошло не так...'">
    </Head>
    <div class="layout-container">
        <TopBar/>
        <main>
            <slot/>
        </main>
        <Footer/>
    </div>
    <OnlyMobile>
        <MobileMenu/>
        <MobileNav/>
    </OnlyMobile>
</template>

<script>
import {Head} from "@inertiajs/vue3";
import {router} from '@inertiajs/vue3';
import {useThemeStore} from "@js/store/ThemeStore.js";
import TopBar from "@/js/components/TopBar/TopBar.vue";
import Footer from "@/js/components/Footer/Footer.vue";
import MobileMenu from "@/js/components/Mobile/MobileMenu.vue";
import MobileNav from "@/js/components/Mobile/MobileNav.vue";
import SpeedDial from "@js/components/Widgets/SpeedDial.vue";
import OnlyMobile from "@js/components/DynamicComponents/OnlyMobile.vue";
import OnlyDesktop from "@js/components/DynamicComponents/OnlyDesktop.vue";
import FormSuccessPopup from "@js/components/Sections/Popup/FormSuccessPopup.vue";
import ErrorPopup from "@js/components/Sections/Popup/ErrorPopup.vue";
import FormAlreadySentPopup from "@js/components/Sections/Popup/FormAlreadySentPopup.vue";
import CallbackPopup from "@js/components/Sections/Popup/CallbackPopup.vue";

export default {
    name: "Layout",
    components: {
        CallbackPopup,
        FormAlreadySentPopup,
        ErrorPopup,
        FormSuccessPopup,
        OnlyDesktop,
        OnlyMobile,
        SpeedDial,
        MobileNav,
        MobileMenu,
        Footer,
        TopBar,
        Head,
    },
    props: {
        title: String,
        description: String
    },
    mounted() {
        router.on("before", (event) => {
            this.themeStore.resetMap()
        })
    },
    setup() {
        const themeStore = useThemeStore()
        themeStore.turnOffMap()

        return {themeStore}
    }
}
</script>

<style lang="scss" scoped>
.layout-container {
    display: flex;
    flex-direction: column;
    min-height: 100vh;

    main {
        flex: 1;
    }
}
</style>
